module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/transient/transient.component.scss
// module id = ./src/app/pages/account/transient/transient.component.scss
// module chunks = main